import React, { useState } from "react";
import getFireRiskInfo from "../../../../utils/getFireRiskInfo";
import calculateFireRisk from "../../../../utils/calculateFireRisk";
import layersEnum from "../../../../utils/enums/layers";
import classes from "./FireRiskAlert.module.css";

const layers = [
	{
		id: layersEnum.activeFire.value,
		name: layersEnum.activeFire.label,
		checked: false,
		icon: "/images/icons/fire.png"
	}, {
		id: layersEnum.wildFireAi.value,
		name: layersEnum.wildFireAi.label,
		checked: true,
		icon: "/images/icons/line_chart_icon.svg"
	}
];

const FireRiskAlert = (props) => {
	const [isLayersDropDownVisible, setIsLayersDropDownVisible] = useState(true);
	let { isOpen, fireRiskValue, setActiveLayers, activeLayers } = props;

	const openLink = (url) => {
		window.open(url);
	};

	const handleSelectLayer = (event, layerId) => {
		const { checked } = event.target;

		if(checked) {
			// Add the layer
			const copy = [...activeLayers];
			copy.push(layerId);

			setActiveLayers(copy);
		} else {
			// remove the layer
			const newLayers = activeLayers.filter(
				(item) => item !== layerId
			);

			setActiveLayers(newLayers)
		}
	};

	const fireCoeficent = calculateFireRisk(+fireRiskValue);
	const { riskLevel, percentElementClassName, riskGaugeColor } = getFireRiskInfo(fireCoeficent)

	return (
		<div style={props.style} className={classes.container}>
			<div className={classes.header}>
				<div className={classes.logo}>
					<img src="/images/terrafuse-logo.svg" alt="logo" />
				</div>

				<div
					className={classes.hideIcon}
					onClick={() => openLink("https://www.terrafuse.ai/")}
				>
					<i className={`fa fa-info-circle ${classes.infoIcon}`} />
				</div>
			</div>

			{isOpen ? (
				<div className={classes.fireRisk}>
					<div className={classes.fireRiskModalName}>
						<div className={classes.titleContainer}>
							<span className={classes.fireRiskModalText}>Wildfire Risk</span>
						</div>
						
						<img
							className={classes.arrowIcon}
							src={isLayersDropDownVisible ? "/images/icons/arrow-up.svg" : "/images/icons/arrow-down.svg"}
							alt="expand icon"
							onClick={() => setIsLayersDropDownVisible(!isLayersDropDownVisible)}
						/>
					</div>
					
					{isLayersDropDownVisible ? (
						<div className={classes.layersList}>
							{layers.map((layer) => {
								return (
									<div className={classes.layerItem} key={layer.name}>
										<div className={classes.layerName}>
											<img
												src={layer.icon}
												alt="fire icon"
												className={classes.layersFireIcon}
											/>
											<span>{layer.name}</span>
										</div>

										<input
											className={classes.checkbox}
											type="checkbox"
											onChange={(event) => handleSelectLayer(event,layer.id)}
											checked={activeLayers.includes(layer.id)}
										/>
									</div>
								);
							})}
						</div>
					) : null}

					<div className={classes.fireRiskModalContent}>
						<div className={`${classes.riskLevel} ${classes[percentElementClassName]}`}>
							{riskLevel}
						</div>

						<div className={classes.gauge}>
							<svg viewBox="0 0 36 36">
								<path
									d="M18 2.0845
								a 15.9155 15.9155 0 0 1 0 31.831
								a 15.9155 15.9155 0 0 1 0 -31.831"
									fill="none"
									stroke={riskGaugeColor}
									strokeWidth="2"
									strokeDasharray="85, 100"
								/>

								<text
									x="18"
									y="20.35"
									className={classes.percentage}
									style={{ fill: riskGaugeColor }}
								>
									{fireCoeficent}
								</text>
							</svg>
						</div>
					</div>
				</div>
			) : null}

		</div>
	);
};

export default FireRiskAlert;
